import fpgConfiguration from '@/store/fpgConfiguration';
import configuration from '@/store/configuration';
import {
  redirectToIamBff,
  buildProxyUrl,
} from '@/services/interceptors/InterceptorUtils';

export function gatewayInterceptor(config) {
  let isTileMode = fpgConfiguration.state.isTileMode;
  let isIamBff = configuration.state.isIamBff;
  if (isTileMode) {
    if (config.baseURL.includes('localhost')) {
      config.baseURL = '/fleet-account' + config.baseURL;
    } else {
      let host = window.location.hostname;
      let decodedConfigUrl = decodeURIComponent(config.url);
      let encodedUrl = encodeURIComponent(
        configuration.state.equipmentApigeeApiBaseUrl
      );
      config.baseURL = buildProxyUrl(host, encodedUrl);
      config.url = encodeURIComponent(decodedConfigUrl);
    }
  } else if (isIamBff)
    redirectToIamBff(config, configuration.state.equipmentApigeeApiBaseUrl);
  return config;
}
